import { Slot } from '@radix-ui/react-slot';
import { cn } from '../../lib/utils';
import { Separator } from './Separator';
import { buttonGroupVariants, buttonGroupTextVariants } from './variants';
import type {
  ButtonGroupProps,
  ButtonGroupTextProps,
  ButtonGroupSeparatorProps,
} from './types';

function ButtonGroup({ className, orientation, ...props }: ButtonGroupProps) {
  return (
    <div
      role='group'
      data-slot='button-group'
      data-orientation={orientation}
      className={cn(buttonGroupVariants({ orientation }), className)}
      {...props}
    />
  );
}

function ButtonGroupText({
  className,
  asChild = false,
  size,
  ...props
}: ButtonGroupTextProps) {
  const Comp = asChild ? Slot : 'div';

  return (
    <Comp
      data-slot='button-group-text'
      className={cn(buttonGroupTextVariants({ size }), className)}
      {...props}
    />
  );
}

function ButtonGroupSeparator({
  className,
  orientation = 'vertical',
  ...props
}: ButtonGroupSeparatorProps) {
  return (
    <Separator
      data-slot='button-group-separator'
      orientation={orientation}
      className={cn(
        'eye:!m-0 eye:relative eye:self-stretch eye:data-[orientation=vertical]:h-auto',
        className,
      )}
      {...props}
    />
  );
}

export { ButtonGroup, ButtonGroupSeparator, ButtonGroupText };
